// components/LoadingProgress.js
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { theme } from '../theme';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const ProgressContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  background: ${theme.colors.white};
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid ${theme.colors.lightGray};
  z-index: 1000;
  animation: ${fadeIn} 0.3s ease-out;
  min-width: 200px;
`;

const ProgressText = styled.div`
  font-size: 12px;
  color: ${theme.colors.darkGray};
  margin-bottom: 8px;
  font-weight: 500;
`;

const ProgressBarContainer = styled.div`
  width: 100%;
  height: 4px;
  background-color: ${theme.colors.lightGray};
  border-radius: 2px;
  overflow: hidden;
`;

const ProgressBar = styled.div`
  height: 100%;
  background: linear-gradient(90deg, ${theme.colors.primary}, ${theme.colors.secondary});
  border-radius: 2px;
  transition: width 0.3s ease-out;
  width: ${props => props.$progress}%;
`;

const ProgressStats = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
  font-size: 10px;
  color: ${theme.colors.mediumGray};
`;

const LoadingProgress = ({
  progress = 0,
  loadedCount = 0,
  totalImages = 0,
  failedCount = 0,
  isVisible = true,
  title = "Cargando imágenes..."
}) => {
  if (!isVisible || totalImages === 0) {
    return null;
  }

  return (
    <ProgressContainer>
      <ProgressText>{title}</ProgressText>
      <ProgressBarContainer>
        <ProgressBar $progress={progress} />
      </ProgressBarContainer>
      <ProgressStats>
        <span>{loadedCount}/{totalImages}</span>
        <span>{progress}%</span>
        {failedCount > 0 && (
          <span style={{ color: theme.colors.error }}>
            {failedCount} fallidas
          </span>
        )}
      </ProgressStats>
    </ProgressContainer>
  );
};

export default LoadingProgress;